import type { RouteRecordRaw } from 'vue-router';
import { configureRouter, type RouterBuilder } from '../routing-services';

export function autoApplyLayoutToRoutes(fn: (route: RouteRecordRaw, builder: RouterBuilder) => any)  {
    configureRouter((builder: RouterBuilder) => {
        for (const route of builder.getRoutes()) {
            route.meta!.layout =  fn(route, builder);
        }
    });
}

export function autoApplyLayoutToRoutesWithAuth(publicLayout: any, privateLayout: any) {
    autoApplyLayoutToRoutes((route: RouteRecordRaw) => {
        return route.meta!.protection ? privateLayout : publicLayout;
    });
}